import EventBus from '_lib/EventBus'
import { reportData } from '_api/report'
import { mapGetters, mapMutations } from "vuex";
import muteSettingMixin from '@/mixin/muteSetting';
import NotifySettingMixin from '@/mixin/notifySetting';
import { checkLoginStatusAsync } from '_lib/utils/utils';
import { FOLDER_SORT_MODE } from '_lib/constants/room';
/* 房间列表左右键菜单 */

export default {
  mixins: [
    muteSettingMixin, 
    NotifySettingMixin
  ],
  computed: {
    ...mapGetters([
      'user_info',
      'user_account_settings',
    ]),
  },
  methods: {
    async shortCutsContextMenuHandler ({room, unreadState}, isTemp, isInFolder, event = null, position = null) {
      if(!await checkLoginStatusAsync()){
        EventBus.$dynamic('Login')
        return
      }
      // 判断是否是公开房间
      let isPublicRoom = room.is_public
      const is_own = room && room.create_by == this.user_info.user_id
      const isDefaultSort = this.user_account_settings.folder_sort === FOLDER_SORT_MODE.DEFAULT
      let notifySubmenu = this.generateNotifySettingSubmenu(room.room_id)
      let contextMenuOptions = {
        groups: [
          {
            items: [
              {
                component: 'menu-button',
                hidden: !(isTemp && isPublicRoom), 
                data: {
                  label: '加入房间',
                  type: 'confirm'
                },
                onClick: ()=>{
                  EventBus.$emit('Join_Public_Room', room.public_id)
                }
              },
              {
                component: 'menu-button',
                data: {
                  label: '邀请其他人',
                  type: 'confirm'
                },
                onClick: ()=> {
                  let params = {
                    user_id: this.user_info.user_id,
                    room_id: room.room_id,
                  }
                  reportData('invite:copy-link', {
                    pos: 'room-list'
                  })
                  EventBus.$emit('Get_Invite_Code', params, (code) => {
                    this.showInviteDialog(room, code)
                  })
                }
              },
              {
                hidden: !(unreadState && (unreadState.redCount || unreadState.showRedPoint)),
                component: 'menu-button',
                data: {
                  label: '标记为已读',
                },
                onClick: ()=> {
                  EventBus.$emit('Update_Unread_States', {
                    "room_id": room.room_id,
                  })
                }
              },
              {
                component: 'child-menu',
                hidden: notifySubmenu.length == 0 || isTemp,
                data: {
                  label: '通知设置',
                  onShowChildMenu: () => {
                    reportData('notification-show', {
                      room_id: room.room_id,
                      pos: 'room-shortcut'
                    })
                  },
                  groups: [
                    { items: notifySubmenu }
                  ]
                },
              },
              // {
              //   component: 'menu-button',
              //   hidden: isManager, 
              //   data: {
              //     label: '房间设置',
              //   },
              //   onClick: ()=>{
              //     EventBus.$emit('show-dynamic-component', 'room-settings', {room_data: room})
              //   }
              // },
              {
                component: 'menu-button',
                hidden: isTemp || isInFolder || position === 0 || !isDefaultSort,
                data: {
                  label: '移动至首位',
                },
                onClick: ()=>{
                  EventBus.$emit('Set_Room_Top', room.room_id)
                }
              },
              this.getMuteMenu(null, room).items[0],
              {
                component: 'menu-button',
                hidden: is_own || isTemp,
                data: {
                  label: '退出房间',
                  type: 'warn'
                },
                onClick: () => {
                  EventBus.$dynamic('RoomLeave', {
                    room_id: room.room_id,
                  })
                }
              }, 
            ]
          },
          
        ],
        event
      }
      this.$contextmenu(contextMenuOptions)
    },
    showInviteDialog (data, code) {
      const invite_data = {
        room_name: data.room_name,
        room_id: data.room_id,
        channel_name: '',
        channel_id: '',
        code
      }
      EventBus.$dynamic('InviteDialog', invite_data)
    },
  },
}
